import type { ReactNode } from 'react'

type ComparisonFooterProps = {
  readonly children: ReactNode
  readonly label: string
}

export function ComparisonFooter({ children, label }: ComparisonFooterProps) {
  return (
    <tr
      className="border-b border-0 border-solid border-neutral-medium last:border-b-0 grid grid-cols-subgrid col-span-full"
      data-testid="ComparisonFooter"
    >
      <th
        scope="row"
        className="font-bold text-sm md:text-2xl pt-2 pb-0 md:pt-6 py-1 flex items-center"
      >
        {label}
      </th>
      {children}
    </tr>
  )
}
